import { useEffect, useRef } from 'react'

import { useSelector, useDispatch } from 'react-redux'
import { routerSlice, type AppsRoutes } from '@wellesley/router'
import { useLocation, useNavigate } from 'react-router-dom'
import { useHostSyncPath } from '../../hooks/useHostSyncPath'
import { useConfirmLeavePage } from '../../hooks/useConfirmLeavePage'
import { useSetPath } from '../../hooks/useSetPath'

export const useHostNavigateToPath = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const lastPathRef = useRef('')
  const path = useSelector(routerSlice.selectors.selectPath)
  const transitionPath = useSelector(routerSlice.selectors.selectTransitionPath)
  const { setPath } = useSetPath()
  const { shouldBlock, message: blockMessage } =
    useSelector(routerSlice.selectors.selectConfirmLeavePage) || {}

  const renderConfirm = useConfirmLeavePage({
    canShowMessage: !!shouldBlock,
    message: blockMessage,
  })

  useHostSyncPath({ lastLocationPathRef: lastPathRef })

  useEffect(() => {
    setPath({ transitionPath })
  }, [location, path, transitionPath, dispatch])

  useEffect(() => {
    if (transitionPath && transitionPath !== lastPathRef.current) {
      lastPathRef.current = transitionPath
      navigate(transitionPath as AppsRoutes, { replace: false })
    }
  }, [transitionPath, navigate])

  return renderConfirm
}
